import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { EVENT_LIST_INFLOW } from '@src/public/constants';
import styles from './index.css';
import Content from './Content';
import Footer from './Footer';

const UnfoldCard = ({ content, timeline, showType, index }) => {
    const isInFlow = showType === EVENT_LIST_INFLOW;

    return (
        <div className={styles.wrap}>
            <Content content={content} showType={showType} timeline={timeline} />
            {!isInFlow ? <Footer content={content} timeline={timeline} index={index} /> : null}
        </div>
    );
};

UnfoldCard.propTypes = {
    content: PropTypes.object,
    timeline: PropTypes.object,
    showType: PropTypes.string,
    index: PropTypes.number,
};

export default errorBoundary(UnfoldCard);
